export class Rule {
  type?: 'number' | 'date' | 'array'
  required?: boolean
  validator?: (rule: any, value: any, callback: (error?: Error) => void) => void
  max?: number
  min?: number
  message?: string
  trigger?: 'change' | 'blur'
  [key: string]: any
}
